import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Page from "components/Page";
import useSearch from "hooks/useSearch";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";
import Pagination from "components/Pagination";
import Tr from "translations/Translations";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import BoldTypography from "components/BoldTypography";
import {makeStyles} from "@material-ui/core";
import moment from "moment";
import DateFormats from "constants/DateFormats";
import Loading from "components/Loading";
import Workspace from "components/Workspace";
import RouterPath from "libs/RouterPath";
import RegistrationService from "services/RegistrationService";
import RegistrationsSearch from "./RegistrationsSearch";
import {RegistrationStatusLabel} from "../constants/RegistrationStatus";

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
    organizationNameColumn: {
        wordBreak: "break-all",
        paddingRight: theme.spacing(2),
    },

    emailColumn: theme.components.table.emailColumn,
    numberColumn: {
        width: 120,
        wordBreak: 'break-all'
    },
    typeColumn: {
        width: 170
    },
    dateTimeColumn: theme.components.table.dateTimeColumn,
    buttonColumn: theme.components.table.buttonColumn,

}));

function RegistrationsList(
    {
        match
    }
) {
    const classes = useStyles();
    const {searchData, totalCount, setTotalCount, setPaginationConfig, setSearchConfig, setSortConfig} = useSearch({
        search: {
            state: "",
            search: ""
        },
        sort: {
            column: 'dateInserted',
            direction: 'desc',
        }
    });
    const [registrationsList, setRegistrationsList] = useState(false);
    const [working, setWorking] = useState();

    useEffect(() => {
        setWorking(true);
        RegistrationService.getRegistrationsList(searchData).then((resp) => {
            setTotalCount(resp.totalCount)
            setRegistrationsList(resp);
        }).finally(() => setWorking(false));
        // eslint-disable-next-line
    }, [searchData]);

    useDidUpdateEffect(() => {
        if (registrationsList?.totalCount !== undefined) {
            setTotalCount(registrationsList.totalCount)
        }
    }, [registrationsList]);

    const goToRegistration = (x) => {
        RouterPath.redirect(RouterPath.createPath(RouterPath.admin.ADMIN_REGISTRATION_ID, {id: x.identity}))
    }

    const handleSortChange = (id) => {
        let direction = 'desc';
        const active = searchData.sort.column === id;
        if (active) {
            direction = searchData.sort.direction === 'asc' ? 'desc' : 'asc';
        }

        setSortConfig({
            column: id,
            direction
        })
    }

    const getSortProps = (id) => {
        return {
            active: searchData.sort.column === id,
            direction: searchData.sort.direction,
            onClick: () => {
                handleSortChange(id)
            }
        }
    }

    const getHeaders = () => {
        const headers = [];
        headers.push({
            value: Tr('organizational_unit'),
            sort: getSortProps('organizationName')
        });
        headers.push({
            value: Tr('date_of_receipt'),
            sort: getSortProps('dateInserted')
        });
        headers.push({
            value: Tr('date_of_decision'),
            sort: getSortProps('decisionDate')
        });
        headers.push({
            value: Tr('status'),
            sort: getSortProps('status')
        });
        headers.push('');
        return headers;
    };

    return (<Page className={classes.root}>
        <Workspace
            title={Tr('registration_user_list')}
        >
            {
                !registrationsList ? <Loading/> :
                    <>
                        <RegistrationsSearch initSearch={searchData.search} doSearch={setSearchConfig} searchInProgress={working}/>

                        <SimpleTable
                            headers={
                                getHeaders()
                            }
                            items={
                                registrationsList.items.map((x, i) => {
                                    return [
                                        x.organizationName,
                                        moment(x.dateInserted).format(DateFormats.DATETIME_FORMAT),
                                        x.decisionDate ? moment(x.decisionDate).format(DateFormats.DATETIME_FORMAT) : null,
                                        x.status ? RegistrationStatusLabel(x.status) : null,
                                        <WorkableIconPreviewButton tooltip={Tr('details')} onClick={() => goToRegistration(x)}/>
                                    ]
                                })
                            }
                            columnClasses={
                                [
                                    classes.organizationNameColumn,
                                    classes.dateTimeColumn,
                                    classes.dateTimeColumn,
                                    classes.numberColumn,
                                    classes.buttonColumn,
                                ]
                            }
                        />
                        {
                            !registrationsList.items.length && <BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography>
                        }
                        <Pagination config={searchData.pagination} setConfig={setPaginationConfig} totalCount={totalCount} disabled={working}/>
                    </>
            }
        </Workspace>
    </Page>)
}

RegistrationsList.propTypes = {
    classes: PropTypes.any,
}

export default RegistrationsList;